import React, { useEffect, useState } from "react"
import { Card, TabContainer, TabContent, TabPane } from "react-bootstrap"
import { TabHeaderRow } from "./TabHeaderRow"
import { TabActiveContext } from "./TabActiveContext";
import { FormItemType } from "../component-map";
import { EventKey } from "@restart/ui/esm/types";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export const TabControl = (props: { field: any; renderItem: any; formView: any; }) => {
  const {field, renderItem, formView} = props;
  const location = useLocation();
  const { items, formState, editMode } = formView;
  const { register, control, watch, formState: { errors }, setValue, handleSubmit, onSubmit, getValues } = formState;
  // Subscribe to any form fields the tab `hide` functions depend on so the tab
  // list reacts to the live form (e.g. the create page). No-op when unset.
  (field.watchFields ?? []).forEach((f: string) => watch?.(f));
  const visibleTabs = useSelector((state) => field.items.filter((item) => !item.hide || !item.hide(state, watch)));
  const requestedTab = new URLSearchParams(location.search).get('tab') ?? decodeURIComponent(location.hash.replace('#', ''));
  const defaultTab = visibleTabs.find((t: { label: string }) => t.label?.toLowerCase() === requestedTab.toLowerCase())?.label;
  const [activeKey, setActiveKey] = useState<EventKey | null>(defaultTab ?? field.items[0].label);
  useEffect(() => {
    if (defaultTab) setActiveKey(defaultTab);
  }, [defaultTab, location.key]);

  return (
    <Card className="card-tabs card-primary flex-grow-1 overflow-auto h-100 p-0">
      <TabContainer activeKey={activeKey ?? undefined} onSelect={(key) => setActiveKey(key)}>
        <TabHeaderRow {...props } />
        <div className="card-body p-0 g-0 w-100 mh-100 flex-grow-1" style={{ overflowX: 'hidden' }}>
          <TabContent className="flex-grow-1 d-flex h-100">
            {visibleTabs.map((tab: { mountOnEnter?: boolean, label: EventKey; unMountOnExit: boolean; items: any[]; footerItems: any; horizontalScroll?: boolean; disableScroll?: boolean }, i: React.Key) => (
              <TabPane key={i} eventKey={tab.label} style={{paddingTop: 12 }} className="flex-grow-1 w-100 h-100" mountOnEnter={tab.mountOnEnter ?? true} unmountOnExit={tab.unMountOnExit}>
                <TabActiveContext.Provider value={activeKey === tab.label}>
                <div style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  flexWrap: 'nowrap'
                }}>
                  <div style={{
                    flexGrow: 1,
                    overflow: tab.disableScroll ? 'hidden' : 'auto',
                    overflowX: tab.horizontalScroll ? 'auto' : 'hidden',
                    minHeight: '2em',

                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexFlow: 'column'
                  }}>
                    {tab.items?.map((x: any) => renderItem(x))}
                  </div>

                  {tab.footerItems && (
                    // @ts-ignore
                    <div style={{ flexShrink: 0, marginLeft: 'auto', padding: 8, borderTop: '1px solid #dee2e6', width: '100%', display: 'inline-flex' }}>
                      {tab.footerItems?.map((x: any) => renderItem(x))}
                    </div>
                  )}
                </div>
                </TabActiveContext.Provider>
              </TabPane>
            ))}
          </TabContent>
        </div>
      </TabContainer>
    </Card>
  )
}